import React from 'react'

export const CardRepeatPerUser = ({ repetByUsers = 0 }) => {
    return (
        <div className="flex justify-center items-center h-full">
            <p className="text-black font-normal text-[48px]">{repetByUsers.toPrecision(3)}</p>
        </div>
    )
}

export default CardRepeatPerUser